(function () {
  'use strict';
  var T = window.HL_CART_T || {};
  var MAP = { 'First name': 'n1', 'Second name': 'n2', 'Back engraving text': 'msg', 'Card': 'card' };
  function fix() {
    var dts = document.querySelectorAll('.cart-items__property dt');
    for (var i = 0; i < dts.length; i++) {
      var dt = dts[i];
      var key = MAP[dt.textContent.replace(/:\s*$/, '').trim()];
      if (!key || !T[key]) continue;
      var want = T[key] + ':';
      if (dt.textContent !== want) dt.textContent = want;
      if (key === 'msg') {
        var dd = dt.nextElementSibling;
        if (dd && !/^“/.test(dd.textContent.trim())) dd.textContent = '“' + dd.textContent.trim() + '”';
      }
    }
  }
  var BACK = { nl: 'Terug naar home', de: 'Zurück zur Startseite', fr: 'Retour à l’accueil', en: 'Back to home' };
  function addBack() {
    if (document.querySelector('.hl-back')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = window.location.pathname.replace(/\/+$/, '') + '/';
    if (path === root || path === '/') return;
    var logo = document.querySelector('.header-logo');
    if (!logo) return;
    var box = logo.parentElement;
    while (box && box.parentElement && box.getBoundingClientRect().width < window.innerWidth * 0.9) box = box.parentElement;
    if (!box) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var lang = (document.documentElement.lang || 'en').slice(0, 2);
    var a = document.createElement('a');
    a.className = 'hl-back';
    a.href = root;
    a.setAttribute('aria-label', BACK[lang] || BACK.en);
    a.innerHTML = '<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
    box.appendChild(a);
  }
  function start() {
    addBack();
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();